var pageConfig = $('#woosmap-config')
var countryCode = tc_vars.env_language.toLowerCase()

module.exports = {
    //projet key from the application.country .conf
    projectKey : cube.stores.WOOSMAP_KEY,
    zoom: pageConfig.data('init-zoom'),
    centerLat: pageConfig.data('init-center-lat'),
    centerlng: pageConfig.data('init-center-lng'),
    country: pageConfig.data('init-country'),
    provider: pageConfig.data('init-provider'),
    language :  countryCode,


    //
    googleConfig: {

       //value config from the file : application.conf
        key: cube.stores.GOOGLE_KEY,
        country: tc_vars.env_country,
        librariesToLoad: ['geometry,places'],
        channelId: cube.stores.GOOGLE_CHANNEL_ID,
        version: '3.31',
        language :  countryCode,
    },

    //
    markersStyle: {
        rules: [
            {
                type: 'drive',
                icon: {url: 'https://developers.woosmap.com/img/markers/marker_drive.svg', scaledSize: {width: 54, height: 60}},
                selectedIcon: {url: 'https://developers.woosmap.com/img/markers/marker_drive_selected.svg', scaledSize: {width: 54, height: 60}}
            }
        ],
        default: {
            icon: {url: '/assets/images/woosmap-market-pin-locator.svg', scaledSize: {width: 54, height: 60}},
            selectedIcon: {url: '/assets/images/woosmap-market-pin-locator-rounded.svg', scaledSize: {width: 12, height: 12}}
        }
    },

    //
    tilesStyle: {
        color: '#0288D1',
        size: 11,
        minSize: 6,
        typeRules: [{
            type: 'drive',
            color: '#FF5722'
        }]
    },

    mapStyle: [
        {
          "featureType": "administrative.land_parcel",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "administrative.neighborhood",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "poi.business",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "road.local",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "transit",
          "stylers": [ { "visibility": "off" } ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text",
          "stylers": [ { "visibility": "off" } ]
        }
      ],

    directions: {
        icons: {
            start: 'https://developers.woosmap.com/img/markers/start.png',
            end: 'https://developers.woosmap.com/img/markers/end.png'
        },
        directionRendererOptions: {
            suppressMarkers: true,
            suppressInfoWindows: true,
            polylineOptions: {
                strokeColor: '#0082c3',
                strokeOpacity: 1.0,
                strokeWeight: 3,
                icons: ['https://developers.woosmap.com/img/markers/marker.png']
            }
        },
        googleDirectionsRequestOptions: {
            provideRouteAlternatives: true,
            durationInTraffic: true
        },
        language :  countryCode
    }

};




// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-config.js